import { render } from "./play.vue?vue&type=template&id=097db29e"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/play.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "097db29e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('097db29e', __exports__)) {
    api.reload('097db29e', __exports__)
  }
  
  module.hot.accept("./play.vue?vue&type=template&id=097db29e", () => {
    api.rerender('097db29e', render)
  })

}


export default __exports__